export default __webpack_public_path__ + "static/media/leaderboad-vi.c2b47681.png";